export const SIDEBAR_WIDTH = 264;

export {
  LANGUAGE_CODES,
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
} from "./languages";
export type { LanguageCode } from "./languages";
